import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {of as observableOf,  Observable } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/response';
import { IAddCustomFont, IAddCustomFontResponse, ICustomFont, ICustomFonts, ICustomFontsForDropdown, IUpdateCustomFont } from './customfonts-model';

@Injectable()
export class CustomFontsService {
    constructor(
        private http: HttpClient
    ) { }

    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}`; }
    private static readonly ENDPOINT = 'customfonts/{customFontId}';

    /** GET */
    public getCustomFont(customFontId: string): Observable<SuccessResponse<ICustomFont> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<ICustomFont>>(
                CustomFontsService.URL +
                CustomFontsService.ENDPOINT.replace('{customFontId}', customFontId)
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public getCustomFonts(): Observable<SuccessResponse<ICustomFonts> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<ICustomFonts>>(
                CustomFontsService.URL +
                'customfonts',
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public getCustomFontsForDropdown(): Observable<SuccessResponse<ICustomFontsForDropdown> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<ICustomFontsForDropdown>>(
                CustomFontsService.URL +
                'customfonts/dropdowns',
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }


    /** PUT */
    public updateCustomFont(customFontId: string, customFontUpdate: IUpdateCustomFont): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .put<SuccessResponse<boolean>>(
                CustomFontsService.URL +
                CustomFontsService.ENDPOINT.replace('{customFontId}', customFontId),
                customFontUpdate
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }


    /** POST */
    public addCustomFont(customFontAdd: IAddCustomFont): Observable<SuccessResponse<IAddCustomFontResponse> | ErrorResponse>  {
        const formData: FormData = new FormData();
        formData.append('displayName', customFontAdd.displayName);
        formData.append('file', customFontAdd.file);

        return this.http
            .post<SuccessResponse<IAddCustomFontResponse>>(
                CustomFontsService.URL +
                'customfonts',
                formData
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }


    /** DELETE */
    public deleteCustomFont(customFontId: string): Observable<SuccessResponse<boolean> | ErrorResponse>  {
        return this.http
            .delete<SuccessResponse<boolean>>(
                CustomFontsService.URL +
                CustomFontsService.ENDPOINT.replace('{customFontId}', customFontId)
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

}
